import { createMuiTheme } from '@material-ui/core/styles';
import { fonts, colors } from './Variables';

export const materialUiTheme = createMuiTheme({
    palette: {
        primary: {
            main: colors.primary['900'],
            header: colors.primary['100'],
        },
        secondary: {
            main: colors.secondary['200'],
        },
        background: {
            default: colors.bodyBG,
        },
    },
    spacing: 10,
    typography: {
        htmlFontSize: 10,
        fontSize: 16,
        fontFamily: fonts.secondary,
        button: {
            fontWeight: 700,
            fontSize: 16,
            textTransform: 'unset',
        },
        body1: {
            fontSize: '1.6rem',
        },
        body2: {
            fontSize: '1.6rem',
        },
        h1: {
            fontFamily: fonts.primary,
            fontSize: '5.4rem',
        },
        h2: {
            fontFamily: fonts.primary,
            fontSize: '4.0rem',
        },
        h3: {
            fontFamily: fonts.primary,
            fontSize: '2.6rem',
        },
        h4: {
            fontFamily: fonts.primary,
            fontSize: '4.0rem',
        },
        h5: {
            fontFamily: fonts.primary,
            fontSize: '2.6rem',
        },
        h6: {
            fontFamily: fonts.primary,
            fontSize: '2.0rem',
        },
    },
    overrides: {
        MuiFormLabel: {
            root: {
                color: colors.primary['200'],
                '&$focused': {
                    color: colors.primary['200'],
                },
            },
            colorSecondary: {
                color: colors.primary['100'],
                '&$focused': {
                    color: colors.primary['100'],
                },
            },
        },
        MuiInputBase: {
            root: {
                color: colors.secondary['200'],
                '&$focused': {
                    color: colors.secondary['200'],
                },
            },
            colorSecondary: {
                color: colors.primary['900'],
                '&$focused': {
                    color: colors.primary['900'],
                },
            },
        },
        MuiInputLabel: {},
        MuiButton: {
            root: {
                borderRadius: 15,
            },
            containedPrimary: {
                '&$disabled': {
                    backgroundColor: colors.primary['100'],
                    color: colors.white,
                },
            },
            containedSecondary: {
                color: colors.white,
                '&$disabled': {
                    backgroundColor: colors.secondary['100'],
                    color: colors.white,
                },
            },
        },
    },
});
